import React, { useState } from "react";
import { buildFBRLink } from "../utils";
import { useFBRLookup } from "../hooks/useLookupNTN.js";
export function NTNSearch({ t }) {
  const [raw,      setRaw]      = useState("");
  const [result,   setResult]   = useState(null);
  const [searched, setSearched] = useState(false);
  const { lookupNTN } = useFBRLookup();

  const go = async () => { if (!raw.trim()) return; setResult(await lookupNTN(raw)); setSearched(true); };
  const clear = () => { setRaw(""); setResult(null); setSearched(false); };
  const isSntn = /^S\d/i.test(raw.trim());

  return (
    <div>
      <div className="form-group">
        <label className="field-label">
          {isSntn ? t("sntn_label") : t("ntn_label")}
          {isSntn && <span className="field-tag field-tag-srb">SRB Sindh</span>}
          {!isSntn && <span className="field-tag">FBR Federal</span>}
        </label>
        <div className="input-wrap">
          <input className="field" value={raw}
            onChange={e => { setRaw(e.target.value); setSearched(false); setResult(null); }}
            onKeyDown={e => e.key === "Enter" && go()}
            placeholder={t("search_placeholder")}
            autoFocus
          />
          {raw && <button className="field-clear" onClick={clear}>✕</button>}
        </div>
      </div>
      <div style={{ display:"flex", gap:8, flexWrap:"wrap", marginBottom:18 }}>
        {["7221683-2","S7221683-2","7221683"].map(ex => (
          <button key={ex} className="example-btn" onClick={() => { setRaw(ex); setResult(null); setSearched(false); }}>{ex}</button>
        ))}
        <span style={{ fontSize:12, color:"var(--text-faint)", fontFamily:"IBM Plex Mono, monospace", alignSelf:"center" }}>— {t("try_example")}</span>
      </div>
      <button className="btn btn-primary btn-full" onClick={go} disabled={!raw.trim()}>{t("search_fbr")}</button>

      {searched && result && (
        <div className={`db-result ${result.found ? "db-found" : "db-miss"}`} style={{ marginTop:20 }}>
          <div className="db-result-status">
            <span className={`db-dot ${result.found ? "db-dot-ok" : "db-dot-miss"}`} />
            <span className="db-result-label">{result.found ? t("found_in_db") : t("not_found_in_db")}</span>
            <span className="db-result-raw">{raw.toUpperCase()}</span>
          </div>

          {result.found && result.wasSntn && (
            <div className="notice notice-info">ℹ️ SNTN <code>{raw.toUpperCase()}</code> — stripped S prefix, searched FBR as <code>{result.clean}</code></div>
          )}
          {result.found && result.checkMismatch && (
            <div className="notice notice-warn">⚠️ Check digit on receipt is <code>-{result.enteredCheck}</code> but FBR stores <code>-{result.storedCheck}</code> — likely a printing error. Business was found using the 7-digit base.</div>
          )}

          {result.found && (
            <div className="rec-table">
              <div className="rec-row"><span className="rec-key">NTN</span><span className="rec-val rec-ntn">{result.record.t}</span></div>
              <div className="rec-row"><span className="rec-key">{t("taxpayer_name")}</span><span className="rec-val">{result.record.nm || "—"}</span></div>
              <div className="rec-row"><span className="rec-key">{t("business_name")}</span><span className="rec-val">{result.record.bn || "—"}</span></div>
              <div className="rec-row"><span className="rec-key">{t("atl_status")}</span><span className="rec-val"><span className="badge-active">✅ {t("active")}</span></span></div>
            </div>
          )}

          {!result.found && (
            <p className="db-miss-msg"><strong>{raw.toUpperCase()}</strong> {result.found ? "" : t("not_found_msg")}</p>
          )}

          <div className="result-actions" style={{ marginTop:14, marginLeft: 10 }}>
            <a className="fbr-btn" href={buildFBRLink(result.found ? result.record.t : result.clean)} target="_blank" rel="noopener noreferrer">🏛️ {t("verify_on_fbr")} →</a>
          </div>
        </div>
      )}
    </div>
  );
}
